import "../styles/app.scss";

const jQuery = require("jquery");

import Splide from "@splidejs/splide";

import { toggle } from "./toggle/toggle.js";
import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
import panzoom from "panzoom";

let CookiesEuBanner = new cookiePolicy();
let Multilevel = new multilevel(".menu, .sub-menu");
let toggleNavicon = new toggle(
  "data-linknavicon",
  "data-targetnavicon",
  "active"
);
let WindowHeight = new windowheight();

export function main() {
  return console.log("Javascript Started");
}

const screen_ti = 280; /* Smallest Mobile | Galaxy Fold   - Tiny */
const screen_xs = 380; /* Large Mobile                    - Extra Small */
const screen_sm = 640; /* Mobile                          - Small */
const screen_md = 768; /* Tablet                          - Medium */
const $screen_lg = 992; /* Tablet                          - Large */
const screen_xl = 1200; /* Tablet / Small Desktop         - Extra Large */
const screen_hg = 1520; /* Medium Desktop                 - Huge */
const screen_ms = 1920; /* Regular Desktop 1080p / HD     - Super Massive */
const screen_smm = 2560; /* Large Desktop                 - Super Massive Massive */
const screen_smbh = 3840; /* 4k                           - Super Massive Black Hole */
const body = document.querySelector("body");

if (document.getElementById("user-email-info")) {
  let userEmail = document.getElementById("user-email-info").textContent;

  if (document.querySelector(".contactform-person input")) {
    document.querySelector(".contactform-person input").value = userEmail;
  }
}

if (document.getElementById("user-username-info")) {
  let userUsername = document.getElementById("user-username-info").textContent;

  if (document.querySelector(".contactform-username input")) {
    document.querySelector(".contactform-username input").value = userUsername;
  }
}

if (document.getElementById("user-displayname-info")) {
  let userDisplayname = document.getElementById(
    "user-displayname-info"
  ).textContent;

  if (document.querySelector(".contactform-displayname input")) {
    document.querySelector(".contactform-displayname input").value =
      userDisplayname;
  }
}

/* Fire an Event */
function eventFire(el, etype) {
  if (el.fireEvent) {
    el.fireEvent("on" + etype);
  } else {
    var evObj = document.createEvent("Events");
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}

inheritLinks();
/* Inherit Links Functionality */
function inheritLinks() {
  var inheritLinks = document.querySelectorAll(".inherit-link");

  inheritLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      let getLink = link.querySelector("a");
      //e.target.nodeName !== "IMG"
      if (!getLink.classList.contains("type-lightbox")) {
        window.location.href = getLink.href;
      } else {
        if (!e.target.closest(".link-lightbox-popup")) {
          initiateLightbox(getLink);
        }
      }
    });
  });
}

var multiWrap = function (toWraps, giveClass, wrapper) {
  wrapper = wrapper || document.createElement("div");

  wrapper.classList.add(giveClass);

  toWraps[0].parentNode.appendChild(wrapper);

  toWraps.forEach((toWrap) => {
    wrapper.appendChild(toWrap);
  });

  return true;
};

// multiWrap([
//   document.querySelector('[data-template="splide-slider-block.twig"]'),
//   document.querySelectorAll('[data-template="splide-slider-block.twig"]')[1],
// ]);

function getInheritedElements(inherited) {
  let count = 5;

  let getSecondSlider = document.querySelectorAll(
    inherited +
      " + " +
      inherited +
      " + " +
      inherited +
      " + " +
      inherited +
      " + " +
      inherited
  );

  if (!getSecondSlider) {
    getSecondSlider = document.querySelectorAll(inherited + " + " + inherited);
    count = 2;
  }

  return { elem: getSecondSlider, count: count };
}

let sliders = getInheritedElements(
  '[data-template="image-floorplans-block.twig"]'
);

// Create Number Prototype
Number.prototype.between = function (a, b) {
  var min = Math.min.apply(Math, [a, b]),
    max = Math.max.apply(Math, [a, b]);
  return this > min && this < max;
};

console.log(sliders);

if (sliders.elem) {
  sliders.elem.forEach((slider) => {
    let sliderCollection = [];

    sliderCollection.push(slider);

    console.log(sliderCollection);

    if (sliders.count.between(1, 100)) {
      // If 2 Slides
      // Select 2
      if (slider.previousElementSibling) {
        sliderCollection.push(slider.previousElementSibling);
      }
    }

    if (sliders.count.between(2, 100)) {
      // If 3 Slides
      // Select 3
      sliderCollection.push(
        slider.previousElementSibling.previousElementSibling
      );
    }

    if (sliders.count.between(3, 100)) {
      // If 4 Slides
      // Select 4
      sliderCollection.push(
        slider.previousElementSibling.previousElementSibling
          .previousElementSibling
      );
    }

    if (sliders.count.between(4, 100)) {
      // If 5 Slides
      // Select 5
      sliderCollection.push(
        slider.previousElementSibling.previousElementSibling
          .previousElementSibling.previousElementSibling
      );
    }

    if (sliders.count.between(5, 100)) {
      // If 6 Slides
      // Select 6
      sliderCollection.push(
        slider.previousElementSibling.previousElementSibling
          .previousElementSibling.previousElementSibling.previousElementSibling
      );
    }

    // Set Final Slide as Active
    sliderCollection[sliderCollection.length - 1].classList.add("active");

    // Reverse the final array in Multi-Wrap
    multiWrap(sliderCollection.reverse(), "GroupSlider");

    sliders.elem = 0;
  });
}

let floorPlansPopulation = document.querySelectorAll(".floorplans-population");

floorPlansPopulation.forEach((floorplans) => {
  let selectColumn = floorplans.querySelectorAll(".wp-block-column");

  selectColumn.forEach((column) => {
    column.classList.add("active");
    column.parentNode.style.position = "relative";
    column.querySelector(".is-description").dataset.height =
      column.querySelector(".is-description").offsetHeight;

    let floorplanChildren = floorplans.querySelector(".GroupSlider").children;

    setTimeout(() => {
      Array.from(floorplanChildren).forEach((elem) => {
        if (elem !== floorplanChildren[0]) {
          elem.style.display = "none";
        }
      });
    }, 1000);

    if (window.innerWidth < screen_sm) {
      selectColumn[0].parentNode.style.paddingBottom =
        selectColumn[0].querySelector(".is-description").dataset.height + "px";
    }

    if (column != selectColumn[0]) {
      column.classList.remove("active");
    }

    column.addEventListener("click", (e) => {
      if (window.innerWidth < screen_sm) {
        column.parentNode.style.paddingBottom =
          column.querySelector(".is-description").dataset.height + "px";
      }

      // Remove Classes
      Array.from(floorplanChildren).forEach((elem) => {
        elem.classList.remove("active");
        elem.style.display = "none";
      });

      selectColumn.forEach((column) => {
        column.classList.remove("active");
      });

      // Add Class
      column.classList.add("active");

      floorplans
        .querySelector(".GroupSlider")
        .children[
          [...column.parentElement.children].indexOf(column)
        ].classList.add("active");

      floorplans.querySelector(".GroupSlider").children[
        [...column.parentElement.children].indexOf(column)
      ].style.display = "block";
    });
  });
});

document.querySelectorAll(".splide").forEach((slider) => {
  let selectNavs = slider.querySelectorAll(".navigator-item");

  selectNavs.forEach((selectNav) => {
    selectNav.addEventListener("click", () => {
      splide[slider.dataset.id].go(selectNav.dataset.slideid - 1);
      console.log(splide[slider.dataset.id]);
      console.log(selectNav.dataset.slideid);
    });
  });
});

/* Animation Functionality */
scrollContainer();

function scrollContainer() {
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  if (isIE11) {
    return;
  }

  let y;
  let ey;
  let attr;
  let wh;
  let setElem = document.querySelectorAll(".animate__me");

  setElem.forEach(function (elem, index) {
    elem.classList.add("anipending");
  });

  window.addEventListener(
    "scroll",
    function (e) {
      attr = setElem;

      attr.forEach(function (elem, index) {
        y = window.scrollY + window.innerHeight;
        ey = elem.offsetTop;

        let aniClassName = elem.dataset.animation;

        if (y > ey) {
          if (!elem.classList.contains("animate__animated")) {
            elem.classList.add("animate__animated");
            elem.classList.add(aniClassName);
            console.log("triggered");
          }
        } else {
          if (elem.classList.contains("animate__animated")) {
            elem.classList.remove("animate__animated");
            elem.classList.remove(aniClassName);
          }
        }
      });
    },
    { passive: true }
  );
}

document.querySelectorAll(".push-image-down").forEach((elem) => {
  elem.closest(".populations").classList.add("outer-space-bottom-200");
});

/* Mapbox */
if (document.getElementById("location_1_map")) {
  mapboxgl.accessToken =
    "pk.eyJ1IjoiZXJoLTEyIiwiYSI6ImNqeTl0ZDkybjA3M20zanF0aDg0ajRsZWgifQ.lZ3_LuDLRjyRkLMbzUrqgQ";

  var map = new mapboxgl.Map({
    container: "location_1_map",
    style: "mapbox://styles/erh-12/cki044akv3e8g19p9s0350d8k", // stylesheet location
    center: [-4.930133424923348, 36.50137264170673], // starting position [lng, lat]
    zoom: 15.5, // starting zoom
  });

  map.scrollZoom.disable();

  map.addControl(new mapboxgl.NavigationControl(), "bottom-right");

  var geojson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Featurea",
        class: "marker-uno",
        name: "",
        properties: {
          message: "Foo",
          iconSize: ["interpolate", ["linear"], ["zoom"], 100, 100, 150, 150],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.930133424923348, 36.50137264170673],
        },
      },
      {
        type: "Featurea",
        class: "marker",
        name: "Club Puente Romano",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.926833424923348, 36.50191264170673],
        },
      },
      {
        type: "Featurea",
        class: "marker-reverse",
        name: "Beach Promenade",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.926633424923348, 36.49977264170673],
        },
      },
      {
        type: "Featureb",
        class: "marker-reverse",
        name: "Victor's Beach",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.932633424923348, 36.50017264170673],
        },
      },
      {
        type: "Featurec",
        class: "marker",
        name: "Centro Comercial Oasis",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.937633424923348, 36.50017264170673],
        },
      },
      {
        type: "Featured",
        class: "marker",
        name: "N-340",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.930633424923348, 36.50227264170673],
        },
      },
      {
        type: "Featured",
        class: "marker",
        name: "King Fahad Alsaud's Palace",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.933813424923348, 36.50357264170673],
        },
      },
      {
        type: "Featured",
        class: "marker",
        name: "Hotel Puente Romano",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.925813424923348, 36.50357264170673],
        },
      },
      {
        type: "Featured",
        class: "marker-reverse",
        name: "Marbella Club Hotel",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.916339468779552, 36.50450356185622],
        },
      },
      {
        type: "Featured",
        class: "marker",
        name: "Marbella",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.88635, 36.509941],
        },
      },
      {
        type: "Featured",
        class: "marker",
        name: "Puerto Banus",
        properties: {
          message: "Foo",
          iconSize: [100, 100],
        },
        geometry: {
          type: "Point",
          coordinates: [-4.95169, 36.488338],
        },
      },
      // {
      //   type: "Featured",
      //   class: "marker",
      //   name: "Puente Romano",
      //   properties: {
      //     message: "Foo",
      //     iconSize: [100, 100],
      //   },
      //   geometry: {
      //     type: "Point",
      //     coordinates: [-4.9241547, 36.504509],
      //   },
      // },
    ],
  };

  geojson.features.forEach(function (marker) {
    // create a DOM element for the marker
    var el = document.createElement("marker1");
    el.className = marker.class;
    el.textContent = marker.name;

    //el.style.width = marker.properties.iconSize[0] + "px";
    //  el.style.height = "140px";

    el.addEventListener("click", function () {
      // window.alert(marker.properties.message);
    });

    // add marker to map
    new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
  });

  /* ON MAPBOX LOAD */
  map.on("load", () => {
    // Remove all Layers
    map.style.stylesheet.layers.forEach(function (layer) {
      if (layer.type === "symbol") {
        map.removeLayer(layer.id);
      }
    });

    /* CREATE POLYGON */
    map.addSource("maine", {
      type: "geojson",
      data: {
        type: "Feature",
        geometry: {
          type: "Polygon",
          // These coordinates outline Maine.
          coordinates: [
            [
              [-4.9324222, 36.5003362],
              [-4.9323578, 36.5013366],
              [-4.9317999, 36.5015005],
              [-4.9317033, 36.5017592],
              [-4.9316282, 36.5018713],
              [-4.9314887, 36.501923],
              [-4.9298794, 36.5022508],
              [-4.9297721, 36.5019834],
              [-4.9296327, 36.5018713],
              [-4.9293644, 36.5019144],
              [-4.9291284, 36.5013193],
              [-4.9288602, 36.500569],
              [-4.928828, 36.5000947],
              [-4.9296005, 36.5003793],
              [-4.9321218, 36.500362],
              [-4.9324329, 36.5003448],
            ],
          ],
        },
      },
    });

    map.addSource("uno", {
      type: "image",
      url: "https://www.unomarbella.com/wp-content/themes/wordpress-theme-uno2021/static/img/uno-15-08-2022/uno-area.png",
      coordinates: [
        [-4.932465, 36.502168],
        [-4.928988, 36.502168],
        [-4.928988, 36.500055],
        [-4.932465, 36.500055],
      ],
    });

    map.addLayer({
      id: "uno-layer",
      type: "raster",
      source: "uno", // reference the data source
      paint: {
        "raster-fade-duration": 0,
        // "fill-color": "#3B3B3B", // blue color fill
        // "fill-opacity": 0.75,
      },
    });
    /* END CREATE POLYGON */

    let p1 = -4.933465; // Y
    let p3 = -4.927988; // Y

    let p2 = 36.503418; // X
    let p4 = 36.501305; // X

    /* Add Map Arrows */
    map.addSource("unoarrow", {
      type: "image",
      url: "https://www.unomarbella.com/wp-content/themes/wordpress-theme-uno2021/static/img/uno-15-08-2022/puerto-marbella-arrows.png",
      coordinates: [
        [p1, p2],
        [p3, p2],
        [p3, p4],
        [p1, p4],
      ],
    });

    map.addLayer({
      id: "uno-layer-arrow",
      type: "raster",
      source: "unoarrow", // reference the data source
      paint: {
        "raster-fade-duration": 0,
        // "fill-color": "#3B3B3B", // blue color fill
        // "fill-opacity": 0.75,
      },
    });
    /* End Map Arrows */
  });
  /* END MAPBOX LOAD */

  /* MAPBOX KEY */
  document.querySelectorAll("[map-reference]").forEach((elem) => {
    elem.addEventListener("click", () => {
      // elem.getAttribute("map-reference");
      // Fly to a random location
      map.flyTo({
        center: [elem.dataset.lat, elem.dataset.lng],
        essential: true, // this animation is considered essential with respect to prefers-reduced-motion
      });
    });
  });
  /* MAPBOX KEY */
}

/* End Mapbox */

let splide = [];

if (!document.querySelector(".wp-admin")) {
  let elms = document.getElementsByClassName("splide");

  if (elms) {
    for (var i = 0, len = elms.length; i < len; i++) {
      if (elms[i].closest(".floorplans-population")) {
        // Target Floor Plans
        splide[i] = new Splide(elms[i], {
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          type: "loop",
        }).mount();
      } else if (elms[i].classList.contains("splide-fade-slider")) {
        // Target Fade Sliders
        splide[i] = new Splide(elms[i], {
          autoplay: 14500,
          pauseOnHover: false,
          pauseOnFocus: false,
          type: "loop",
        }).mount();
      } else {
        // Target all other (normal) sliders
        splide[i] = new Splide(elms[i], {
          type: "fade",
          rewind: true,
          speed: 2000,
          arrows: false,
          pagination: false,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
        }).mount();
      }

      splide[i].root.dataset.id = i;
    }
  }
}

let getPopulations = document.querySelectorAll(".populations");

getPopulations.forEach((getPopulation) => {
  let dataInputContent = getPopulation.querySelector("[data-input-content]"); // Input Content
  let dataOutputContent = getPopulation.querySelector("[data-output-content]"); // Output Content

  if (dataInputContent && dataOutputContent) {
    let selectGalleryBlock = getPopulation.querySelector(".gallery-block");
    let selectListItems = getPopulation.querySelectorAll(".gallery-block li");

    selectGalleryBlock
      .closest(".populations")
      .querySelector(".is-gallery-active")
      .addEventListener("click", () => {
        selectGalleryBlock
          .closest(".populations")
          .querySelector(".is-gallery-active")
          .classList.remove("gallery-active");
        selectGalleryBlock.classList.remove("active");
        selectListItems.forEach((selectListItem) => {
          selectListItem.classList.remove("active");
        });
      });

    selectListItems.forEach((selectListItem) => {
      selectListItem.addEventListener("click", () => {
        selectGalleryBlock
          .closest(".populations")
          .querySelector(".is-gallery-active")
          .classList.add("gallery-active");

        selectGalleryBlock.classList.add("active");

        selectListItems.forEach((elem) => {
          elem.classList.remove("active");
        });

        selectListItem.classList.add("active");
        dataOutputContent.innerHTML = selectListItem.querySelector(
          "[data-input-content]"
        ).innerHTML;
      });
    });
  }
});

let getLinkLightboxs = document.querySelectorAll(".type-lightbox");

getLinkLightboxs.forEach((getLinkLightbox) => {
  getLinkLightbox.addEventListener("click", (e) => {
    e.preventDefault(e);
    initiateLightbox(getLinkLightbox);
  });
});

function initiateLightbox(glTarget) {
  let target = glTarget.nextSibling;
  if (
    target.classList.contains("link-lightbox-popup") &&
    !target.classList.contains("active")
  ) {
    target.classList.add("active");
    body.classList.add("link-lightbox-popup-active");
  }

  console.log(target);
}

removeLightbox(getLinkLightboxs);

function removeLightbox(glTargets) {
  glTargets.forEach((glTarget) => {
    let target = glTarget.nextSibling;
    target.addEventListener("click", (e) => {
      if (e.target.nodeName !== "IMG") {
        console.log("close");
        console.log(target);
        target.classList.remove("active");
        body.classList.remove("link-lightbox-popup-active");
      }
    });
  });
}

function nativeSelector() {
  var elements = document.querySelectorAll("body, body *");
  var results = [];
  var child;
  for (var i = 0; i < elements.length; i++) {
    child = elements[i].childNodes[0];
    if (elements[i].hasChildNodes() && child.nodeType == 3) {
      results.push(child);
    }
  }
  return results;
}

String.prototype.allReplace = function (obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
  }
  return retStr;
};

// let dataRepObj = {
//     "{{ getProfileName }}" : "yolo1123",
//     "{{ getProfileName2 }}" : "This is the replaced content"
//   };

var textnodes = nativeSelector(),
  _nv;

for (var i = 0, len = textnodes.length; i < len; i++) {
  _nv = textnodes[i].nodeValue;
  let str = _nv;
  str = _nv.allReplace(dataRepObj);
  textnodes[i].nodeValue = str;
}

injectElem(".inject-mobile-image", ".image-block");
injectElem(".inject-mobile-button", ".button-block");
injectElem(".inject-mobile-gallery", ".GroupSlider");

document
  .querySelectorAll(".tabs-pin-block, .masterplan-sizer, .masterplan-btn-block")
  .forEach((elem) => {
    injectElem(".inject-mobile-tabs-pin-block", elem);
  });

function injectElem(moveTo, toMove) {
  let injector = document.querySelectorAll(moveTo);

  injector.forEach((inject) => {
    let findColumns = inject.closest(".populations");
    let source = "";

    if (!toMove.nodeType) {
      source = findColumns.querySelector(toMove);
    } else {
      source = toMove;
    }

    let target = inject.querySelector(".inner");

    if (window.innerWidth < screen_sm) {
      target.appendChild(source);
    }
  });
}

let masterplanViewState = false;
let masterplanCurrentTab = 0;
let masterplanView = document.querySelector(".masterplan-btn-block");

masterplanView.addEventListener("click", () => {
  masterplanViewState = !masterplanViewState;

  let ii = 0;

  if (masterplanViewState) {
    ii = 3;
  } else {
    ii = 0;
  }

  masterplanView.querySelectorAll("span").forEach((elem, i) => {
    elem.classList.remove("active");

    if (masterplanViewState) {
      if (i == 1) {
        elem.classList.add("active");
      }
    } else {
      if (i == 0) {
        elem.classList.add("active");
      }
    }
  });

  let parentBlock = masterplanView.closest(".populations");

  console.log(parentBlock);

  parentBlock.querySelectorAll(".tabs-pin-block").forEach((allElem) => {
    allElem.classList.remove("active");
  });

  let getPinBlock =
    parentBlock.querySelectorAll(".tabs-pin-block")[
      Number(masterplanCurrentTab) + ii
    ];

  if (getPinBlock) {
    getPinBlock.classList.add("active");
  }

  let getContentBlock = parentBlock.querySelectorAll(".tabs-content-block")[
    Number(masterplanCurrentTab) + ii
  ];

  console.log("hello");

  if (getContentBlock) {
    getContentBlock.classList.add("active");
  }
});

let tabBarBlocks = document.querySelectorAll(".tabs-bar-block");

tabBarBlocks.forEach((tabBarBlock) => {
  let parentBlock = tabBarBlock.closest(".populations");
  let tabs = tabBarBlock.querySelectorAll(".is-tab");

  // Create first tab as active
  parentBlock.querySelectorAll(".tabs-pin-block")[0].classList.add("active");
  parentBlock
    .querySelectorAll(".tabs-content-block")[0]
    .classList.add("active");
  tabs[0].classList.add("active");

  tabs.forEach((tab, i) => {
    tab.addEventListener("click", () => {
      let ii = 0;

      if (masterplanViewState === true) {
        ii = 3;
      }

      parentBlock
        .querySelectorAll(".tabs-content-block, .tabs-pin-block, .is-tab")
        .forEach((allElem) => {
          allElem.classList.remove("active");
        });

      tab.classList.add("active");

      masterplanCurrentTab = tab.dataset.tabindex;

      let getPinBlock =
        parentBlock.querySelectorAll(".tabs-pin-block")[
          Number(tab.dataset.tabindex) + ii
        ];

      if (getPinBlock) {
        getPinBlock.classList.add("active");
      }
      console.log(Number(tab.dataset.tabindex) + ii);
      console.log(masterplanCurrentTab);

      let getContentBlock = parentBlock.querySelectorAll(".tabs-content-block")[
        Number(tab.dataset.tabindex)
      ];

      if (getContentBlock) {
        getContentBlock.classList.add("active");
      }
    });
  });
});

// Function to add an element ot the DOM
const createNewNavElement = (appendTo) => {
  if (!appendTo) {
    console.error(
      "Element not found whilst using the [ createNewNavElement(<element>) ] function"
    );
    return false;
  }

  let newElem = document.createElement("div");
  newElem.classList.add("nav-line");
  appendTo.appendChild(newElem);

  return newElem;
};

// Function to a group of elemnts from DOM
const removeOtherNavElement = (removeTo) => {
  removeTo.forEach((elem) => {
    elem.remove();
  });
};

function manageNavUnderline() {
  const manageNavSelection = (element) => {
    let getAllMenuItems = document.querySelectorAll(
      ".header-bar-elements .nav-main-link"
    );

    let getMainNav = document.querySelector(".nav-main .current_page_item");

    if (!getMainNav) {
      getMainNav = document.querySelector(
        ".header-bar-elements .nav-main-link"
      );
    }

    getAllMenuItems.forEach((menuitem) => {
      menuitem.addEventListener("mouseover", (e) => {
        // Get boundaries of parent element
        let mainNavRect = getMainNav.getBoundingClientRect();

        // Get Boundries of element
        let rect = menuitem.getBoundingClientRect();

        // Move element with Boundries
        document.querySelector(".nav-line").style.left =
          rect.left - -rect.width / 2 - mainNavRect.left + "px";
        document.querySelector(".nav-line").style.width = "4.17vw";
      });

      // Remove style on mouse out and maintain origional style
      menuitem.addEventListener("mouseout", (e) => {
        document.querySelector(".nav-line").style.left = null;
        document.querySelector(".nav-line").style.width = null;
      });
    });
  };

  if (document.querySelector(".header-bar-elements .current_page_item")) {
    // Create Initial Item
    let element = createNewNavElement(
      document.querySelector(".header-bar-elements .current_page_item")
    );

    if (element) {
      manageNavSelection(element);
    } else {
      let element = createNewNavElement(
        document.querySelector(".header-bar-elements .nav-main")
      );
      manageNavSelection(element);
    }
  }
}

manageNavUnderline();

// const pzelem = document.getElementById('panzoom-element');

// const panzoomx = Panzoom(pzelem, {
//   contain: 'outside'
// });

// // panzoomx.zoom(2, { animate: true });
// // panzoomx.zoom(1.5, { animate: true });

// document.getElementById('zoomin').addEventListener('click', () => {

//   setTimeout(() =>  panzoomx.zoom(4, { force: true }), 100)
// });
// document.getElementById('zoomout').addEventListener('click', () => {

//   setTimeout(() => panzoomx.zoom(1, { force: true }), 100)
// });

// // document.getElementById('zoomout').addEventListener('click', () => {
// //   panzoom.zoom(1, { animate: true });
// // });

// toggle class on and off
document.querySelectorAll(".masterplan-toggle").forEach((elem) => {
  elem.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    elem.classList.toggle("active");

    console.log(document.querySelector(".image-pane").offsetWidth / 2);

    // setTimeout(() => {
    //   instance.smoothMoveTo(0.5, 0.5)
    //   }, 1000);
  });
});

var element = document.querySelector("#panzoom-element");
if (element) {
  var elementHeight =
    document.querySelector(".image-pane-inner").offsetHeight / 2;
  var elementWidth =
    document.querySelector(".image-pane-inner").offsetWidth / 2;

  // var elementHeight = document.querySelector('.image-pane').offsetHeight;
  // var elementWidth = document.querySelector('.image-pane').offsetWidth;

  console.log(-(document.querySelector(".tabs-pin-block").offsetWidth / 2));

  document.querySelector(".tabs-pin-block").offsetWidth / 2;

  var instance = panzoom(element, {
    maxZoom: document.querySelector(".tabs-pin-block").offsetWidth / 1500,
    minZoom: document.querySelector(".tabs-pin-block").offsetWidth / 6500,
    // initialX: -200,
    // initialY: -200,
    // initialX: -(document.querySelector('.tabs-pin-block').offsetWidth / 4),
    // initialY: -(document.querySelector('.tabs-pin-block').offsetHeight / 4),
    initialZoom: document.querySelector(".tabs-pin-block").offsetWidth / 6500,
    // bounds: false,
    // boundsPadding: 0,
    transformOrigin: { x: 0.5, y: 0.5 },
    //startScale: 1.5,
    beforeWheel: function (e) {
      // allow wheel-zoom only if altKey is down. Otherwise - ignore
      var shouldIgnore = !e.altKey;
      return shouldIgnore;
    },
  });

  // let origin = instance.getTransformOrigin(); // {x: 0.5, y: 0.5}
  // instance.setTransformOrigin({x: 0.5, y: 0.5}); // now it is topLeft

  document.getElementById("zoomin").addEventListener("click", () => {
    //instance.zoom(3, { animate: true });

    console.log(instance);
    //setTimeout(() => {

    instance.zoomTo(
      document.querySelector(".image-pane").offsetWidth / 2,
      document.querySelector(".image-pane").offsetHeight / 2,
      3
    );

    // }, 100);
    element.classList.add("zoomed");
  });

  document.getElementById("zoomout").addEventListener("click", () => {
    instance.zoomTo(
      document.querySelector(".image-pane").offsetWidth / 2,
      document.querySelector(".image-pane").offsetHeight / 2,
      0.5
    );

    // setTimeout(() => { instance.zoom(
    //   (document.querySelector('.image-pane').offsetWidth / 2),
    //   (document.querySelector('.image-pane').offsetHeight / 2),
    //   0.25)
    // }, 100);
    element.classList.remove("zoomed");
  });

  // Datapin
  const getDataPin = document.querySelectorAll("[data-pin-id]");

  getDataPin.forEach((dataPin) => {
    ["click", "touchstart"].forEach((item) => {
      dataPin.addEventListener(item, () => {
        getDataPin.forEach((remPin) => {
          remPin.classList.remove("active");
        });

        document
          .querySelectorAll('[data-pin-id="' + dataPin.dataset.pinId + '"]')
          .forEach((pin) => {
            pin.classList.add("active");
          });
      });
    });
  });
}
